<div
  [class.is-current-frame]="isCurrentFrame$ | async"
  [class.in-range]="isInRange$ | async"
  class="frame-container"
>
  <div class="frame-number-indicator">
    <span>{{ frameNumber }}</span>
  </div>
  <div
    class="frame visibility-{{ visibility$ | async }}"
    [class.hasKeyLocation]="isKeyLocation$ | async"
    [class.isDynamicFrame]="isDynamicKeyFrame$ | async"
    [class.is-ml-frame]="isMlFrame$ | async"
    [class.is-object]="isObject$ | async"
    [class.is-ml-pending-frame]="isMlPendingFrame$ | async"
  >
    <mat-icon
      *ngIf="isDynamicKeyFrameOnly$ | async"
      svgIcon="dynamicFrame"
    ></mat-icon>
    <mat-icon
      *ngIf="isKeyLocationOnly$ | async"
      svgIcon="keyLocation"
    ></mat-icon>
    <ng-container *ngIf="isDynamicKeyLocation$ | async">
      <svg height="10" width="10">
        <circle cx="5" cy="5" r="4" fill="white" />
      </svg>
      <svg viewBox="0 0 3 3" class="dynamicKeyframe">
        <polygon points="1.5 0, 0 1.5, 1.5 3, 3 1.5" />
      </svg>
    </ng-container>
  </div>
  <div class="ruler-number">
    <span [class.frame-number]="isFrameDisplayedInRuler$ | async">{{
      frameNumber
    }}</span>
  </div>
  <div
    class="frame-ruler"
    [class.highlighted]="isFrameDisplayedInRuler$ | async"
    [class.has-feedback]="hasFeedback$ | async"
  ></div>
</div>
